import { X } from "lucide-react";

// Modal that embeds a YouTube/Vimeo player.
export default function VideoEmbed({ title, src, onClose }) {
  return (
    <div data-testid="video-embed-modal" className="fixed inset-0 z-[70] bg-black/70 flex items-center justify-center px-4" onClick={onClose}>
      <div className="w-full max-w-3xl animate-pop" onClick={(e) => e.stopPropagation()}>
        <div className="flex items-center justify-between mb-2">
          <h3 className="font-display text-lg font-bold text-[#fff8e1]">{title}</h3>
          <button data-testid="video-embed-close" onClick={onClose} className="w-9 h-9 border-2 border-[var(--gold)] rounded-lg flex items-center justify-center text-[#fff8e1] hover:bg-[var(--gold)] hover:text-[#0b1d3a] transition-colors">
            <X className="w-4 h-4" />
          </button>
        </div>
        <div className="aspect-video rounded-xl overflow-hidden border-2 border-[var(--gold)] bg-black">
          <iframe
            title={title}
            src={src}
            className="w-full h-full"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
          />
        </div>
      </div>
    </div>
  );
}
